import { render, staticRenderFns } from "./procurables.vue?vue&type=template&id=665f3935&"
import script from "./procurables.vue?vue&type=script&lang=js&"
export * from "./procurables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports